import React, { useState, useEffect } from "react";
import { Input, Textarea, Select, SelectItem, Button } from "@nextui-org/react";

const ConditionalField = ({ 
  field, 
  formData, 
  onChange, 
  existingFields 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [dependentValue, setDependentValue] = useState("");



  // Check if the conditional field should be visible
  useEffect(() => {
    // For existing conditional fields that might have the wrong structure
    const dependentField = field.dependentField || field.id;
    const triggerValue = field.triggerValue || field.name;
    
    if (dependentField && triggerValue) {
      const dependentFieldValue = formData[dependentField];
      const shouldShow = dependentFieldValue === triggerValue;
      console.log("Conditional check:", {
        dependentField,
        triggerValue,
        actualValue: dependentFieldValue,
        shouldShow
      });
      setIsVisible(shouldShow);
    }
  }, [formData, field.dependentField, field.triggerValue, field.id, field.name]);

  // Handle field value changes
  const handleFieldChange = (value) => {
    onChange(field.title, value);
  };

  // Render different field types
  const renderField = () => {
    switch (field.type) {
      case "text":
        return (
          <Input
            type="text"
            label={field.title}
            placeholder={`Enter ${field.title.toLowerCase()}`}
            variant="faded"
            labelPlacement="outside"
            value={formData[field.title] || ""}
            onChange={(e) => handleFieldChange(e.target.value)}
            isRequired={field.required}
          />
        );

      case "textarea":
        return (
          <Textarea
            label={field.title}
            placeholder={`Enter ${field.title.toLowerCase()}`}
            variant="faded"
            labelPlacement="outside"
            value={formData[field.title] || ""}
            onChange={(e) => handleFieldChange(e.target.value)}
            isRequired={field.required}
          />
        );

      case "integer":
        return (
          <Input
            type="number"
            label={field.title}
            placeholder={`Enter ${field.title.toLowerCase()}`}
            variant="faded"
            labelPlacement="outside"
            value={formData[field.title] || ""}
            onChange={(e) => handleFieldChange(e.target.value)}
            isRequired={field.required}
          />
        );

      case "dropdown":
        const options = field.framework?.split(",").map(opt => opt.trim()) || [];
        return (
          <Select
            label={field.title}
            placeholder={`Select ${field.title.toLowerCase()}`}
            variant="faded"
            labelPlacement="outside"
            selectedKeys={formData[field.title] ? [formData[field.title]] : []}
            onSelectionChange={(keys) => {
              const selectedValue = Array.from(keys)[0];
              handleFieldChange(selectedValue);
            }}
            isRequired={field.required}
          >
            {options.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </Select>
        );

      case "file":
        return (
          <div>
            <label className="block text-sm font-medium mb-2">
              {field.title} {field.required && <span className="text-red-500">*</span>}
            </label>
            <input
              type="file"
              onChange={(e) => handleFieldChange(e.target.files[0])}
              className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-emerald-50 file:text-emerald-700 hover:file:bg-emerald-100"
            />
          </div>
        );

      default:
        return (
          <Input
            type="text"
            label={field.title}
            placeholder={`Enter ${field.title.toLowerCase()}`}
            variant="faded"
            labelPlacement="outside"
            value={formData[field.title] || ""}
            onChange={(e) => handleFieldChange(e.target.value)}
            isRequired={field.required}
          />
        );
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="text-xs text-gray-500 mb-2 italic">
        This field appears when "{field.dependentField || field.id}" is set to "{field.triggerValue || field.name}"
      </div>
      {renderField()}
    </div>
  );
};

export default ConditionalField; 